"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PermanentIndustrialIdentification() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const stats = [{
    label: "Veteran-owned"
  }, {
    label: "US-based production"
  }, {
    label: "Precision-marked"
  }];
  return <section data-section-id="849" id="permanent-industrial-identification" className="relative w-full min-h-[90vh] bg-background text-foreground overflow-hidden">
      {}
      <div aria-hidden="true" className="absolute inset-y-0 left-0 w-full lg:w-[58%] pointer-events-none" style={{
      backgroundImage: "linear-gradient(to right, var(--foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "48px 48px",
      opacity: 0.04
    }} />

      <div className="relative grid grid-cols-1 lg:grid-cols-[58%_42%] min-h-[90vh]">
        {}
        <div ref={leftRef} className={`relative flex flex-col justify-center px-6 sm:px-10 lg:pl-[120px] lg:pr-12 py-20 lg:py-24 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="flex items-center gap-3 mb-8 font-mono text-xs tracking-widest uppercase text-muted-foreground">
            <span>[ INDUSTRIAL</span>
            <span className="w-1.5 h-1.5 rounded-lg bg-chart-1" aria-hidden="true" />
            <span>COMPLIANT</span>
            <span className="w-1.5 h-1.5 rounded-lg bg-chart-1" aria-hidden="true" />
            <span>SPECIFIED ]</span>
          </div>

          {}
          <h1 className="font-sans font-default text-foreground mb-8" style={{
          fontSize: "clamp(3rem, 7vw, 7rem)",
          lineHeight: "0.95",
          letterSpacing: "-0.03em"
        }}>Projects Large or Small.<br />  Phenolic to Metals.</h1>

          {}
          <p className="font-default text-base sm:text-lg text-muted-foreground max-w-2xl mb-10 leading-relaxed">Industrial laser marking and engraving services for critical infrastructure. Phenolic plates, stainless steel tags, and MIL-SPEC identification delivered to your exact specifications.<br /><br />Whether you have a sketch or schematic - let's talk!</p>

          {}
          <div className="flex flex-wrap items-center gap-6 mb-10">
            <Button asChild size="lg" className="bg-accent text-accent-foreground hover:bg-accent/90 px-7 h-12 shadow-md">
              <Link to="/CapabilitiesPage">
                View Capabilities
                <ArrowRight className="ml-1 size-4" />
              </Link>
            </Button>

            <Link to="/ContactPage" className="group inline-flex items-center gap-1.5 text-foreground font-default text-sm">
              <span className="relative">Let's talk about your project</span>
              <span aria-hidden="true">→</span>
            </Link>
          </div>

          {}
          <div className="h-px w-full max-w-2xl bg-border mb-6" />

          {}
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 font-mono text-xs uppercase tracking-wider text-muted-foreground">
            {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-center gap-5">
                {i > 0 && <span className="text-chart-1">·</span>}
                <span>{stat.label}</span>
              </div>)}
          </div>
        </div>

        {}
        <div ref={rightRef} className={`relative w-full h-[60vh] lg:h-auto lg:min-h-[90vh] transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-6"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving_steel.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving_steel.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving_steel.png-wvc-sizes" alt="Industrial laser engraving on stainless steel" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" style={{
          filter: "saturate(0.85) contrast(1.05)"
        }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/Stainless_Steel_Plates-scaled.png" />
          {}
          <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{
          boxShadow: "inset 0 0 80px 0 hsla(220, 40%, 11%, 0.35)"
        }} />

          {}
          <div className={`absolute bottom-6 left-6 sm:bottom-10 sm:-left-8 lg:-left-12 z-10 bg-card text-card-foreground rounded-none shadow-2xl p-5 sm:p-6 w-[260px] sm:w-[280px] transition-all duration-1000 ease-out delay-700 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="flex items-center gap-2.5 mb-3">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full bg-chart-3 opacity-75 animate-ping" />
                <span className="relative inline-flex h-2.5 w-2.5 bg-chart-3" style={{
                backgroundColor: "hsl(142 70% 45%)"
              }} />
              </span>
              <span className="font-default text-sm font-semibold text-foreground">
                Production active
              </span>
            </div>
            <div className="font-mono text-xs uppercase tracking-wider" style={{
            color: "var(--chart-1)"
          }}>
              [ Lead time: 3-5 days ]
            </div>
          </div>
        </div>
      </div>
    </section>;
}